import React from "react";
import styled from "styled-components";

const ShimmerContainer = styled.div(({ theme }) => ({
    width: "100%",
    height: "100%",
    background: `linear-gradient(
        90deg,
        ${theme.colors[theme.colorMode].background_Primary} 0%,
        ${theme.colors[theme.colorMode].background_Secondary_Alpha} 50%,
        ${theme.colors[theme.colorMode].background_Primary} 100%
    )`,
}));

const ShimmerView = () => {
    return <ShimmerContainer />;
};

export default ShimmerView;
